import React from "react";
import { BioInfo, DownloadButton } from "../../styles/ResumeStyles";
import styled from "styled-components";

const Bio = () => {
  return (
    <>
      <a
        href="/Resume-Naheel.pdf"
        download={`Resume_Naheel_${new Date().getFullYear()}`}
      >
        <DownloadButton className="download__button">
          Download PDF
        </DownloadButton>
      </a>
      <BioInfo>
        <h1>Naheel Palliyali</h1>
        <div>
          <BioItem>
            <img src={"mailIcon.png"} alt={"mail icon"} />
            naheel.palliyali@gmail.com
          </BioItem>
          <BioItem>
            <img src={"phone.png"} alt={"phone"} />
            +91 8129119570
          </BioItem>
          {/*<p>DOB: 6-Sept-1995</p>*/}
          <BioItem>
            <img src={"address.png"} alt={"address"} />
            Kerala, India
          </BioItem>
        </div>
      </BioInfo>
    </>
  );
};

export default Bio;

const BioItem = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 28px;

  img {
    height: 16px;
    opacity: 0.3;
  }
`;
